<ng-container *ngIf="passolutionData">
    <div style="display: flex;align-items: center;justify-content: space-between;">
        <h2 multilang style="margin:0">{{passolutionData?.title}} - Quelle: Passolution</h2>
        <button mat-icon-button aria-label="Export pdf" matTooltip="Exportieren als PDF" (click)="exportPdf()">
            <mat-icon>picture_as_pdf</mat-icon>
        </button>
    </div>
    <ng-container *ngIf="passolutionData.corona?.content?.length > 0">
        <ng-container *ngTemplateOutlet="content; context:{cont:passolutionData.corona}"></ng-container>
    </ng-container>
    <ng-container *ngIf="passolutionData.entry?.content?.length > 0">
        <ng-container *ngTemplateOutlet="content; context:{cont:passolutionData.entry}"></ng-container>
    </ng-container>
    <ng-container *ngIf="passolutionData.visa?.content?.length > 0">
        <ng-container *ngTemplateOutlet="content; context:{cont:passolutionData.visa}"></ng-container>
    </ng-container>
    <ng-container *ngIf="passolutionData.transit_visa?.content?.length > 0">
        <ng-container *ngTemplateOutlet="content; context:{cont:passolutionData.transit_visa}"></ng-container>
    </ng-container>
    <ng-container *ngIf="passolutionData.health?.content?.length > 0">
        <ng-container *ngTemplateOutlet="content; context:{cont:passolutionData.health}"></ng-container>
    </ng-container>
    <ng-container *ngIf="passolutionData.final_provisions?.content?.length > 0">
        <ng-container *ngTemplateOutlet="content; context:{cont:passolutionData.final_provisions}"></ng-container>
    </ng-container>
</ng-container>

<ng-container *ngIf="currentRegionData?.content?.length > 0">
    <div class="passwrapper">
        <div class="ausheader">
            <div style="display: flex;align-items: center;"
                (click)="currentRegionData.showContent = !currentRegionData.showContent;">
                <img height="24px" style="margin-right: 10px;" *ngIf="currentRegionData?.flagUrl?.length > 0"
                    data-src="{{currentRegionData?.flagUrl}}" class="lazyload" alt="flag">
                <h2 multilang style="margin: 0;font-size: 1.1rem;">{{currentRegionData?.title}} - Quelle: Auswärtiges
                    Amt</h2>
            </div>
            <button mat-icon-button (click)="currentRegionData.showContent = !currentRegionData.showContent;"
                *ngIf="!currentRegionData.showContent">
                <mat-icon>expand_more</mat-icon>
            </button>
            <button mat-icon-button (click)="currentRegionData.showContent = !currentRegionData.showContent;"
                *ngIf="currentRegionData.showContent">
                <mat-icon>expand_less</mat-icon>
            </button>
        </div>
        <ng-container *ngIf="currentRegionData.showContent">
            <div style="display: flex;flex-direction: column;margin: auto;align-self: center;padding: .5rem;">
                <h2 multilang style="padding: .5rem">Einreise und Aufenthalt</h2>
            </div>
            <div multilang [innerHTML]="currentRegionData.content | safehtml" class="auswertigamt">
            </div>
        </ng-container>
    </div>
</ng-container>


<ng-template #content let-cont="cont">
    <div class="passwrapper">
        <div class="passHeader noselect" (click)="cont.show = !cont.show">
            <h2 multilang style="margin: 0;font-size: 1.1rem;">{{cont.title}}</h2>
            <button mat-icon-button *ngIf="!cont.show">
                <mat-icon>expand_more</mat-icon>
            </button>
            <button mat-icon-button *ngIf="cont.show">
                <mat-icon>expand_less</mat-icon>
            </button>
        </div>
        <ng-container *ngIf="cont.show">
            <div multilang [innerHTML]="cont.content | safehtml" class="contentWrapper"></div>
        </ng-container>
    </div>
</ng-template>